const getLink = (isLoggedIn, featureUrl) => {
  if (isLoggedIn) {
    return featureUrl;
  }
  return null;
};

export { getLink };
